// Getters
export const teams = (state) => {
  return state.teams.data || []
}
export const teamsSortedActive = (state) => {
  return (
    [...(state.teams.data || [])].sort((a, b) => {
      return a.ativo === b.ativo ? 0 : a.ativo ? -1 : 1
    }) || []
  )
}
export const teamsLoading = (state) => {
  return state.teams.loading
}
export const teamsLastUpdate = (state) => {
  return state.teams.lastUpdate
}

export const roas = (state) => {
  return state.roas.data || []
}
export const roasLoading = (state) => {
  return state.roas.loading
}
export const roasLastUpdate = (state) => {
  return state.roas.lastUpdate
}
export const familyGroup = (state) => {
  return state.familyGroup.data || []
}
export const familyGroupLoading = (state) => {
  return state.familyGroup.loading
}
export const familyGroupLastUpdate = (state) => {
  return state.familyGroup.lastUpdate
}

export const benchmarks = (state) => {
  return state.benchmarks.data || []
}
export const benchmarksLoading = (state) => {
  return state.benchmarks.loading
}
export const benchmarksLastUpdate = (state) => {
  return state.benchmarks.lastUpdate
}

export const officeParametrization = (state) => {
  return state.officeParametrization.data || []
}
export const officeParametrizationLoading = (state) => {
  return state.officeParametrization.loading
}
export const officeParametrizationLastUpdate = (state) => {
  return state.officeParametrization.lastUpdate
}

export const rubrics = (state) => {
  return state.rubrics.data || []
}
export const rubricsLoading = (state) => {
  return state.rubrics.loading
}
export const rubricsLastUpdate = (state) => {
  return state.rubrics.lastUpdate
}
export const departments = (state) => {
  return state.departments.data || []
}
export const departmentsLoading = (state) => {
  return state.departments.loading
}
export const departmentsLastUpdate = (state) => {
  return state.departments.lastUpdate
}

export const permissionsAssessor = (state) => {
  return state.permissionsAssessor.data || []
}
export const permissionsAssessorLoading = (state) => {
  return state.permissionsAssessor.loading
}
export const permissionsAssessorLastUpdate = (state) => {
  return state.permissionsAssessor.lastUpdate
}

export const routesSettings = (state) => {
  return state.routesSettings
}
export const repositoryFiles = (state) => {
  return state.repositoryFiles.data || []
}
export const repositoryFilesLoading = (state) => {
  return state.repositoryFiles.loading
}
export const repositoryFilesLastUpdate = (state) => {
  return state.repositoryFiles.lastUpdate
}

export const assetAllocationTypes = (state) => {
  return state.assetAllocationTypes.data || []
}
export const assetAllocationTypesLoading = (state) => {
  return state.assetAllocationTypes.loading
}
export const assetAllocationTypesLastUpdate = (state) => {
  return state.assetAllocationTypes.lastUpdate
}

export const dreTempFilters = (state) => {
  return state.dreTempFilters.data || {}
}

export const superRankingClusters = (state) => {
  return state.superRankingClusters.data || []
}
export const superRankingClustersLoading = (state) => {
  return state.superRankingClusters.loading
}
export const superRankingClustersLastUpdate = (state) => {
  return state.superRankingClusters.lastUpdate
}

export const superRankingCycles = (state) => {
  return state.superRankingCycles.data || []
}
export const superRankingCyclesLoading = (state) => {
  return state.superRankingCycles.loading
}
export const superRankingCyclesLastUpdate = (state) => {
  return state.superRankingCycles.lastUpdate
}

export const superRankingIndicators = (state) => {
  return state.superRankingIndicators.data || []
}
export const superRankingIndicatorsLoading = (state) => {
  return state.superRankingIndicators.loading
}
export const superRankingIndicatorsLastUpdate = (state) => {
  return state.superRankingIndicators.lastUpdate
}

export const superRankingFunctions = (state) => {
  return state.superRankingFunctions.data || []
}
export const superRankingFunctionsLoading = (state) => {
  return state.superRankingFunctions.loading
}
export const superRankingFunctionsLastUpdate = (state) => {
  return state.superRankingFunctions.lastUpdate
}

export const openFinanceConexoes = (state) => {
  return state.openFinanceConexoes || { index: [], data: [] }
}
